<label class="checkbox-container" [matTooltip]="tooltip">
  <input data-cy="tick-checkbox__check-handle-input" type="checkbox" #checkbox class="check-handle" (click)="handle(checkbox.checked)" [checked]="value | async">
  <span class="checkmark"></span>
</label>
